export default __webpack_public_path__ + "static/media/iCrypto-min.5a83248e.png";